module.exports = __webpack_public_path__ + "img/saya_elizabeth.6d5409dc.png";